<template>
  <div class="flex justify-center">
    <div>
      <div class="flex justify-center">
        <div class="check-container">
          <div class="check-background">
            <svg
              viewBox="0 0 65 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 25L27.3077 44L58.5 7"
                stroke="white"
                stroke-width="13"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="check-shadow"></div>
        </div>
      </div>
      <h2 class="text-center text-2xl font-semibold text-gray-300">
        {{ title }}
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: "Compra realizada com sucesso" },
    active: { type: Boolean, default: false },
    size: { type: Number, default: 100 },
  },
};
</script>

<style lang="scss" scoped>
// Main CSS
.check-container {
  width: 6.25rem;
  height: 7.5rem;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;

  .check-background {
    width: 100%;
    height: calc(100% - 1.25rem);
    background: linear-gradient(to bottom right, #19d684, #17c177);
    box-shadow: 0px 0px 0px 65px rgba(255, 255, 255, 0.25) inset,
      0px 0px 0px 65px rgba(255, 255, 255, 0.25) inset;
    transform: scale(0.84);
    border-radius: 50%;
    animation: animateContainer 0.75s ease-out forwards 0.75s;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;

    svg {
      width: 65%;
      transform: translateY(0.25rem);
      stroke-dasharray: 80;
      stroke-dashoffset: 80;
      animation: animateCheck 0.35s forwards 1.25s ease-out;
    }
  }

  .check-shadow {
    bottom: calc(-15% - 5px);
    left: 0;
    border-radius: 50%;
    background: radial-gradient(closest-side, rgba(45, 55, 72, 1), transparent);
    animation: animateShadow 0.75s ease-out forwards 0.75s;
  }
}

@keyframes animateContainer {
  0% {
    opacity: 0;
    transform: scale(0);
    box-shadow: 0px 0px 0px 65px rgba(255, 255, 255, 0.25) inset,
      0px 0px 0px 65px rgba(255, 255, 255, 0.25) inset;
  }
  25% {
    opacity: 1;
    transform: scale(0.9);
    box-shadow: 0px 0px 0px 65px rgba(255, 255, 255, 0.25) inset,
      0px 0px 0px 65px rgba(255, 255, 255, 0.25) inset;
  }
  43.75% {
    transform: scale(1.15);
    box-shadow: 0px 0px 0px 43.334px rgba(255, 255, 255, 0.25) inset,
      0px 0px 0px 65px rgba(255, 255, 255, 0.25) inset;
  }
  62.5% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px rgba(255, 255, 255, 0.25) inset,
      0px 0px 0px 21.667px rgba(255, 255, 255, 0.25) inset;
  }
  81.25% {
    box-shadow: 0px 0px 0px 0px rgba(255, 255, 255, 0.25) inset,
      0px 0px 0px 0px rgba(255, 255, 255, 0.25) inset;
  }
  100% {
    opacity: 1;
    box-shadow: 0px 0px 0px 0px rgba(255, 255, 255, 0.25) inset,
      0px 0px 0px 0px rgba(255, 255, 255, 0.25) inset;
  }
}

@keyframes animateCheck {
  from {
    stroke-dashoffset: 80;
  }
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes animateShadow {
  0% {
    opacity: 0;
    width: 100%;
    height: 15%;
  }
  25% {
    opacity: 0.25;
  }
  43.75% {
    width: 40%;
    height: 7%;
    opacity: 0.35;
  }
  100% {
    width: 85%;
    height: 15%;
    opacity: 0.25;
  }
}

:root {
  --hue: 223;
  --bg: hsl(var(--hue), 90%, 20%);
  --fg: hsl(var(--hue), 10%, 90%);
  --primary: hsl(var(--hue), 90%, 55%);
  --primary-dn: hsl(var(--hue), 90%, 45%);
  font-size: calc(16px + (24 - 16) * (100vw - 320px) / (1280 - 320));
}

.check-spinner__worm-a,
.check-spinner__worm-b {
  visibility: hidden;
}
.check-spinner {
  margin-bottom: 3em;
  overflow: visible;
  width: 6.25em;
  height: 6.25em;
}
.check-spinner__worm-a {
  animation: worm-a 1.2s linear;
}
.check-spinner__worm-b {
  animation: worm-b 1.2s 1.2s linear forwards;
  stroke-dashoffset: 0.01;
}
.check-spinner__circle {
  animation: circle 0.2s 2.3s cubic-bezier(0, 0, 0.42, 1.33) forwards;
}

/* Animations */
@keyframes worm-a {
  from {
    stroke-dashoffset: 36.1;
    visibility: visible;
  }
  to {
    stroke-dashoffset: -252.9;
    visibility: visible;
  }
}
@keyframes worm-b {
  from {
    animation-timing-function: linear;
    stroke-dasharray: 0 0 72.2 341.3;
    visibility: visible;
  }
  69.7% {
    animation-timing-function: ease-out;
    stroke-dasharray: 0 207 45 341.3;
    visibility: visible;
  }
  to {
    animation-timing-function: ease-out;
    stroke-dasharray: 0 297 45 341.3;
    visibility: visible;
  }
}
@keyframes circle {
  from {
    r: 0;
  }
  to {
    r: 50px;
  }
}
@keyframes reappear {
  from {
    visibility: hidden;
  }
  to {
    visibility: visible;
  }
}
</style>
